















import Vue, { PropOptions } from 'vue';

export type TemplateCard = Blok & {
  title: string;
  image: { filename: string };
  link: { url: string; target: string };
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<TemplateCard>,
  },
});
